exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nstrong[data-v-9cd4ed2c] {\n    font-weight: 500;\n}\n", ""]);

// exports
